export default __webpack_public_path__ + "static/logo-d726b360f6d6be25eef7afa3484672e5.png";